var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "content_box" },
      [
        _c(
          "v-card",
          { staticClass: "settings_panel_card", attrs: { flat: "" } },
          [
            _c(
              "v-toolbar",
              {
                staticClass: "settings_toolbar",
                attrs: { flat: "", dense: "" }
              },
              [
                _c(
                  "v-toolbar-title",
                  { staticClass: "settings_panel_heading" },
                  [_vm._v("Users with access")]
                ),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                !_vm.showUsersWithoutAccessList
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          color: "grey lighten-3",
                          depressed: "",
                          small: ""
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            class:
                              _vm.usersWithoutAccessData.length == 0
                                ? "emptyUsers"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.showListOfUserWithoutAccess()
                              }
                            }
                          },
                          [_vm._v("add")]
                        )
                      ],
                      1
                    )
                  : _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          color: "grey lighten-3",
                          depressed: "",
                          small: ""
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            class:
                              _vm.usersWithoutAccessData.length == 0
                                ? "emptyUsers"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.cancellistOfUserWithoutAccess()
                              }
                            }
                          },
                          [_vm._v("clear")]
                        )
                      ],
                      1
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "apps_table_div" }, [
              _c(
                "table",
                { staticClass: "users_with_access_component_table" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("User")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Last Used ")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("App Role")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("App administrator")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Actions")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.usersWithAccessData, function(item, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "td",
                            [
                              _c("v-icon", { attrs: { color: "purple" } }, [
                                _vm._v("person")
                              ]),
                              _vm._v(
                                " \n                                " +
                                  _vm._s(item.username) +
                                  "\n                            "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.last_login || "-"))]),
                          _vm._v(" "),
                          !_vm.apptypeRoles.length
                            ? _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.role[0]) +
                                    "\n                            "
                                )
                              ])
                            : _c(
                                "td",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.apptypeRoles,
                                      label: "App role",
                                      multiple: "",
                                      chips: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.selectedDropDownValue(item)
                                      }
                                    },
                                    model: {
                                      value: item.role,
                                      callback: function($$v) {
                                        _vm.$set(item, "role", $$v)
                                      },
                                      expression: "item.role"
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c("td", [
                            item.user_role == "appAdmin" ||
                            item.user_role == "User"
                              ? _c("span", [
                                  item.is_appAdmin
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons checkBox",
                                          attrs: {
                                            title: "remove user as app admin"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.makeUserAsAppAdminMethod(
                                                item,
                                                index,
                                                "true"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("check_box")]
                                      )
                                    : _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons checkBox",
                                          attrs: {
                                            title: "make user as app admin"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.makeUserAsAppAdminMethod(
                                                item,
                                                index,
                                                "false"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("check_box_outline_blank")]
                                      )
                                ])
                              : _c("span", [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons checkBox_disable",
                                      attrs: {
                                        title:
                                          "User is tenant admin or Super admin"
                                      }
                                    },
                                    [_vm._v("check_box")]
                                  )
                                ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons user_delete",
                                on: {
                                  click: function($event) {
                                    return _vm.addDeleteUser(item, "delete")
                                  }
                                }
                              },
                              [_vm._v("clear")]
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.usersWithoutAccessData, function(item, index) {
                        return _vm.showUsersWithoutAccessList
                          ? _c("tr", [
                              _c(
                                "td",
                                [
                                  _c("v-icon", { attrs: { color: "purple" } }, [
                                    _vm._v("person")
                                  ]),
                                  _vm._v(
                                    " \n                                " +
                                      _vm._s(item.username) +
                                      "\n                            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.last_login))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.role) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                item.user_role == "appAdmin" ||
                                item.user_role == "User"
                                  ? _c("span", [
                                      item.is_appAdmin
                                        ? _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons checkBox",
                                              attrs: {
                                                title:
                                                  "remove user as app admin"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.makeUserAsAppAdminMethod(
                                                    item,
                                                    index,
                                                    "true"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("check_box")]
                                          )
                                        : _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons checkBox",
                                              attrs: {
                                                title: "make user as app admin"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.makeUserAsAppAdminMethod(
                                                    item,
                                                    index,
                                                    "false"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("check_box_outline_blank")]
                                          )
                                    ])
                                  : _c("span", [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons checkBox_disable",
                                          attrs: {
                                            title:
                                              "User is tenant admin or Super admin"
                                          }
                                        },
                                        [_vm._v("check_box")]
                                      )
                                    ])
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "user_table_Add",
                                    on: {
                                      click: function($event) {
                                        return _vm.addDeleteUser(item, "add")
                                      }
                                    }
                                  },
                                  [_vm._v("add")]
                                )
                              ])
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }